import {createTheme} from "@mui/material";
import {frFR} from "@mui/material/locale";

const variableStyle = getComputedStyle(document.documentElement);

const getPropertyValue = (propName) => {
    return variableStyle.getPropertyValue(propName).trim();
};

const theme = createTheme(
    {
        palette: {
            primary: {
                main: getPropertyValue("--nuances-rouges-medium-candy-apple"),
            },
            error: {
                main: getPropertyValue("--nuances-rouges-medium-candy-apple"),
                light: getPropertyValue("--nuances-rouges-light-pink"),
            },
            success: {
                main: getPropertyValue("--statut-green"),
                light: getPropertyValue("--statut-light-green"),
            },
            warning: {
                main: getPropertyValue("--statut-orange"),
                light: getPropertyValue("--statut-light-orange"),
            },
            textDark: getPropertyValue("--primaire-outer-space"),
            lightBackground: getPropertyValue("--primaire-light-outer-space"),
            darkBorder: getPropertyValue("--primaire-outer-space"),
            lightBorder: getPropertyValue("--niveau-de-gris-gris-3"),
            highlight: getPropertyValue("--nuances-rouges-medium-candy-apple"),
            highlightBackground: getPropertyValue("--nuances-rouges-light-pink"),
        },
        components: {
            MuiButton: {
                defaultProps: {
                    variant: "contained",
                },
                styleOverrides: {
                    root: {
                        fontWeight: 500,
                        fontSize: "18px",
                        textTransform: "none",
                        "&.MuiButton-contained:hover": {
                            backgroundColor: getPropertyValue("--nuances-rouges-electric-crimson"),
                        },
                    },
                },
            },
            MuiLink: {
                styleOverrides: {
                    root: {
                        fontWeight: 500,
                        fontSize: "14px",
                        marginTop: "15px",
                        marginBottom: "15px",
                        "&:hover": {
                            textDecoration: "none",
                            color: getPropertyValue("--nuances-rouges-electric-crimson"),
                        },
                        "&[disabled]": {
                            color: "grey",
                            cursor: "default",
                            textDecoration: "none",
                        },
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: getPropertyValue("--primaire-dim-gray"),
                        "&.Mui-focused": {
                            color: getPropertyValue("--primaire-dim-gray"),
                        },
                    },
                },
            },
            MuiInput: {
                styleOverrides: {
                    root: {
                        color: getPropertyValue("--primaire-noir-texte"),
                        "&.Mui-focused::after": {
                            borderBottom: "solid 1px",
                            borderBottomColor: getPropertyValue("--niveau-de-gris-gris-2"),
                        },
                    },
                },
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        color: variableStyle.getPropertyValue("--primaire-noir-texte"),
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        color: variableStyle.getPropertyValue("--primaire-outer-space"),
                        backgroundColor: variableStyle.getPropertyValue("--primaire-white"),
                        boxShadow: "none",
                    },
                },
            },
            MuiLinearProgress: {
                styleOverrides: {
                    root: {
                        backgroundColor: "#fef5f7",
                        height: "8px",
                    },
                    bar: {
                        borderRadius: "0 4px 4px 0",
                    },
                },
            },
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        display: "flex",
                    },
                },
            },
            MuiDrawer: {
                styleOverrides: {
                    paper: ({ownerState}) => ({
                        ...(ownerState.overridestheme === "top-shadow" ? {
                            boxShadow: "0px -3px 6px -5px #333",
                            borderRadius: "15px 15px 0 0",
                            padding: "20px",
                            maxWidth: "900px",
                            margin: "auto",
                            maxHeight: "90%",
                        } : null),

                    }),
                },
                variants: [
                    {
                        props: {variant: "helper-popin"},
                        style: {
                            height: "100%",
                        },
                    },
                ],
            },
            MuiListItemText: {
                styleOverrides: {
                    root: {
                        color: getPropertyValue("--primaire-noir-texte"),
                    },
                },
            },
            MuiMobileStepper: {
                styleOverrides:{
                    dotActive: {
                        backgroundColor: getPropertyValue("--primaire-outer-space"),
                    },
                },
            },

            MuiStepIcon: {
                styleOverrides: {
                    root: {
                        border: "solid #eeeeee",
                        borderRadius: "20%",
                        color: getPropertyValue("--primaire-light-outer-space"),
                        "& .MuiStepIcon-text":{
                            fill: getPropertyValue("--primaire-outer-space"),
                        },
                    },
                },
            },
        },
    },
    frFR
);
export default theme;